import { ReactNode } from 'react'
import { motion } from 'framer-motion'
import Navigation from './Navigation'
import Footer from './Footer'
import BookingModal from './BookingModal'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50/30 via-secondary-50/30 to-accent-50/30 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800">
      <Navigation />
      
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative min-h-screen"
      >
        {children}
      </motion.main>
      
      <Footer />
      <BookingModal />
    </div>
  )
}
